import { Button } from "antd";
import { ClockCircleOutlined } from "@ant-design/icons";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { startSetEnEsperaUsuario } from "../../../../context/actions/incidenciasActions";

export const BotonEnEsperaUsuario = () => {
  const { asistenciaID } = useParams();
  const dispatch = useDispatch();
  const { enEsperaUsuario } = useSelector(
    (state) => state.detalleReducer.asistencia
  );

  const handleClick = () => dispatch(startSetEnEsperaUsuario(asistenciaID));
  return (
    <Button
      onClick={handleClick}
      type="dashed"
      danger
      icon={<ClockCircleOutlined />}
    >
      {enEsperaUsuario ? "Quitar Espera de Usuario" : "Establecer en Espera de Usuario"}
    </Button>
  );
};
